// variables.js
export const footerNavigationHeight = 48;
export const userProfileFooterHeight = 48;
export const iPhoneXSeriesFooterPaddingInPWA = 34;
export const headerHeight = 64;
export const browseTabHeight = 40;
export const pinnedNotificationOnDesktopHeight = 60;
export const pinnedNotificationOnTabletHeight = 48;
export const pinnedNotificationOnMobileHeight = 70;
export const color = {
  black: '#191919',
  black_alpha_50: '#19191980',
  white: '#ffffff',
  grey: {
    100: '#F6F6F6',
    300: '#C8C8C8',
    500: '#9B9B9B',
    700: '#646464',
    900: '#232323',
  },
  /**
   * @type {Neutral}
   * @property {string} 0 - #191919
   * @property {string} 0_alpha_0 - #19191900
   * @property {string} 0_alpha_20 - #19191933
   * @property {string} 0_alpha_30 - #1919194d
   * @property {string} 0_alpha_40 - #19191966
   * @property {string} 0_alpha_50 - #19191980
   * @property {string} 0_alpha_60 - #19191999
   * @property {string} 0_alpha_70 - #191919b3
   * @property {string} 0_alpha_80 - #191919cc
   * @property {string} 0_alpha_90 - #191919e6
   * @property {string} 0_alpha_95 - #191919f2
   * @property {string} 5 - #1e1e1e
   * @property {string} 10 - #232323
   * @property {string} 10_alpha_0 - #23232300
   * @property {string} 10_alpha_35 - #23232359
   * @property {string} 10_alpha_40 - #23232366
   * @property {string} 10_alpha_50 - #23232380
   * @property {string} 10_alpha_60 - #23232399
   * @property {string} 10_alpha_80 - #232323cc
   * @property {string} 20 - #474747
   * @property {string} 20_alpha_20 - #47474733
   * @property {string} 20_alpha_40 - #47474766
   * @property {string} 20_alpha_80 - #474747cc
   * @property {string} 30 - #646464
   * @property {string} 30_alpha_10 - #6464641a
   * @property {string} 30_alpha_15 - #64646426
   * @property {string} 30_alpha_20 - #64646433
   * @property {string} 30_alpha_25 - #64646440
   * @property {string} 30_alpha_30 - #6464644d
   * @property {string} 30_alpha_40 - #64646466
   * @property {string} 30_alpha_50 - #64646480
   * @property {string} 30_alpha_80 - #646464cc
   * @property {string} 30_alpha_90 - #646464e6
   * @property {string} 45 - #808080
   * @property {string} 55 - #9b9b9b
   * @property {string} 55_alpha_5 - #9b9b9b0d
   * @property {string} 55_alpha_10 - #9b9b9b1a
   * @property {string} 55_alpha_20 - #9b9b9b33
   * @property {string} 55_alpha_50 - #9b9b9b80
   * @property {string} 65 - #aeaeae
   * @property {string} 75 - #c8c8c8
   * @property {string} 75_alpha_20 - #c8c8c833
   * @property {string} 75_alpha_50 - #c8c8c880
   * @property {string} 85 - #dddddd
   * @property {string} 85_alpha_20 - #dddddd33
   * @property {string} 95 - #f6f6f6
   * @property {string} 100 - #ffffff
   * @property {string} 100_alpha_5 - #ffffff0d
   * @property {string} 100_alpha_10 - #ffffff1a
   * @property {string} 100_alpha_20 - #ffffff33
   * @property {string} 100_alpha_30 - #ffffff4d
   * @property {string} 100_alpha_35 - #ffffff59
   * @property {string} 100_alpha_40 - #ffffff66
   * @property {string} 100_alpha_50 - #ffffff80
   * @property {string} 100_alpha_60 - #ffffff99
   * @property {string} 100_alpha_70 - #ffffffb3
   * @property {string} 100_alpha_75 - #ffffffbf
   * @property {string} 100_alpha_80 - #ffffffcc
   * @property {string} 100_alpha_90 - #ffffffe6
   */
  neutral: {
    0: '#191919',
    '0_alpha_0': '#19191900',
    '0_alpha_20': '#19191933',
    '0_alpha_30': '#1919194d',
    '0_alpha_40': '#19191966',
    '0_alpha_50': '#19191980',
    '0_alpha_60': '#19191999',
    '0_alpha_70': '#191919b3',
    '0_alpha_80': '#191919cc',
    '0_alpha_90': '#191919e6',
    '0_alpha_95': '#191919f2',
    5: '#1e1e1e',
    10: '#232323',
    '10_alpha_0': '#23232300',
    '10_alpha_35': '#23232359',
    '10_alpha_40': '#23232366',
    '10_alpha_50': '#23232380',
    '10_alpha_60': '#23232399',
    '10_alpha_80': '#232323cc',
    20: '#474747',
    '20_alpha_20': '#47474733',
    '20_alpha_40': '#47474766',
    '20_alpha_80': '#474747cc',
    30: '#646464',
    '30_alpha_10': '#6464641a',
    '30_alpha_15': '#64646426',
    '30_alpha_20': '#64646433',
    '30_alpha_25': '#64646440',
    '30_alpha_30': '#6464644d',
    '30_alpha_40': '#64646466',
    '30_alpha_50': '#64646480',
    '30_alpha_80': '#646464cc',
    '30_alpha_90': '#646464e6',
    45: '#808080',
    55: '#9b9b9b',
    '55_alpha_5': '#9b9b9b0d',
    '55_alpha_10': '#9b9b9b1a',
    '55_alpha_20': '#9b9b9b33',
    '55_alpha_50': '#9b9b9b80',
    65: '#aeaeae',
    75: '#c8c8c8',
    '75_alpha_20': '#c8c8c833',
    '75_alpha_50': '#c8c8c880',
    85: '#dddddd',
    '85_alpha_20': '#dddddd33',
    95: '#f6f6f6',
    100: '#ffffff',
    '100_alpha_5': '#ffffff0d',
    '100_alpha_10': '#ffffff1a',
    '100_alpha_20': '#ffffff33',
    '100_alpha_30': '#ffffff4d',
    '100_alpha_35': '#ffffff59',
    '100_alpha_40': '#ffffff66',
    '100_alpha_50': '#ffffff80',
    '100_alpha_60': '#ffffff99',
    '100_alpha_70': '#ffffffb3',
    '100_alpha_75': '#ffffffbf',
    '100_alpha_80': '#ffffffcc',
    '100_alpha_90': '#ffffffe6',
  },
  /**
   * @type {Blue}
   * @property {string} 10 - #EDF4FC
   * @property {string} 40 - #B7D3F3
   * @property {string} 80 - #6EA6E8
   * @property {string} 100 - #4B90E2
   * @property {string} 100_alpha_40 - #4B90E266
   * @property {string} 140 - #2C5688
   */
  blue: {
    10: '#EDF4FC',
    40: '#B7D3F3',
    80: '#6EA6E8',
    100: '#4B90E2',
    '100_alpha_40': '#4B90E266',
    140: '#2C5688',
  },
  tealBlue: '#00d2be',
  tealBlue_alpha_10: '#00d2be1a',
  tealBlue_alpha_20: '#00d2be33',
  tealBlue_alpha_40: '#00d2be66',
  tealBlue_alpha_80: '#00d2becc',
  darkTeal_alpha_20: '#007e7233',
  peach: '#FF7878',
  peach_alpha_20: '#FF787833',
  sky: '#60c4e8',
  sky_alpha_40: '#60c4e866',
  yellow: '#FFD100',
  yellowTan: '#fee573',
  yellow_alpha_40: '#FFD10066',
  yellow_alpha_80: '#FFD100cc',
  green: '#83CC38',
  lime: '#82ff8c',
  red: '#cf0404',
  purple: '#734eff',
  purple_alpha_40: '#734eff66',
  purple_alpha_80: '#8238bacc',
  carmine: '#d41872',
  salmon: '#ff7878',
  softBlue: '#5e81f4',
  blushPink: '#fd8a94',
  lovense: '#f6418d',
  lovense_alpha_40: '#f6418d66',
  lovense_alpha_80: '#f6418dcc',
  orange: '#f5a623',
  orange_alpha_80: '#ff6200cc',
  campaignGradient:
    'linear-gradient(90deg, #00d2c1 0%, #5d82bc 48.44%, #8e37d7 100%)',
  campaignScan: '#00e8ff',
  giftSelectionGradient:
    'linear-gradient(136deg, rgba(164, 69, 179, 1), rgba(212, 24, 114, 1), rgba(255, 0, 102, 1))',
  giftSelectionOverlay:
    'linear-gradient(360deg, rgba(58, 58, 58, 0) 48.81%, rgba(160, 160, 160, 0.4) 117.98%)',
  cupidGiftEntryGlow:
    'radial-gradient(circle, rgba(255, 110, 110, 0.6) 0%, rgba(255, 110, 110, 0) 70%)',
  emailInputPlaceholder: '#757575',
};

export const textColor = {
  black: color.grey['700'],
  white: color.white,
  grey: color.grey['300'],
  primary: color.tealBlue,
  secondary: color.sky,
  danger: color.red,
  success: color.lime,
  softBlue: color.softBlue,
  blushPink: color.blushPink,
};
export const toastrColor = {
  success: 'rgba(0, 210, 190, 0.6)',
  error: 'rgba(207, 4, 4, 0.6)',
  info: 'rgba(255, 255, 255, 0.8)',
};

export const vipStatusCardLabelColor = {
  level_100: '#00D2BECC',
  level_90: '#DCD7EF',
  level_80: '#C5FBA6',
  level_70: '#FEAEAE',
  level_60: '#BBC7F3',
  level_50: '#C5ACAC',
  level_40: '#D8D398',
  level_30: '#F2CFC1',
  level_20: '#D0BD99',
  level_10: '#B1B1B1',
  level_1: '#CEAC98',
  level_0: '#D1CBC8',
};

export const vipStatusCardContainerColor = {
  level_100: 'linear-gradient(226.07deg, #00B3A2 -15.9%, #1B1717 80.43%)',
  level_90: 'linear-gradient(226.07deg, #705580 -15.9%, #26172F 80.43%)',
  level_80: 'linear-gradient(226.07deg, #4C6634 -15.9%, #112717 80.43%)',
  level_70: 'linear-gradient(226.07deg, #E66161 -15.9%, #2C1E1E 80.43%)',
  level_60: 'linear-gradient(226.07deg, #4960B0 -15.9%, #111523 80.43%)',
  level_50: 'linear-gradient(226.07deg, #FFB691 -15.9%, #27120B 80.43%)',
  level_40: 'linear-gradient(226.07deg, #ADAD33 -15.9%, #2D2002 80.43%)',
  level_30: 'linear-gradient(226.07deg, #FD946E -15.9%, #39291B 80.43%)',
  level_20: 'linear-gradient(226.07deg, #FFD877 -15.9%, #39291B 80.43%)',
  level_10: 'linear-gradient(226.07deg, #BEBEBD -15.9%, #1B1717 80.43%)',
  level_1: 'linear-gradient(226.07deg, #635853 -15.9%, #1B1717 80.43%)',
  level_0: 'linear-gradient(226.07deg, #4B4B4B -15.9%, #242424 80.43%)',
};

export const vipStatusCardContainerHoverColor = {
  level_100: 'linear-gradient(226.07deg, #00B3A266 -15.9%, #1B171766 80.43%)',
  level_90: 'linear-gradient(226.07deg, #70558066 -15.9%, #26172F66 80.43%)',
  level_80: 'linear-gradient(226.07deg, #4C663466 -15.9%, #11271766 80.43%)',
  level_70: 'linear-gradient(226.07deg, #E6616166 -15.9%, #2C1E1E66 80.43%)',
  level_60: 'linear-gradient(226.07deg, #4960B066 -15.9%, #11152366 80.43%)',
  level_50: 'linear-gradient(226.07deg, #FFB69166 -15.9%, #27120B66 80.43%)',
  level_40: 'linear-gradient(226.07deg, #ADAD3366 -15.9%, #2D200266 80.43%)',
  level_30: 'linear-gradient(226.07deg, #FD946E66 -15.9%, #39291B66 80.43%)',
  level_20: 'linear-gradient(226.07deg, #FFD87766 -15.9%, #39291B66 80.43%)',
  level_10: 'linear-gradient(226.07deg, #BEBEBD66 -15.9%, #1B171766 80.43%)',
  level_1: 'linear-gradient(226.07deg, #63585366 -15.9%, #1B171766 80.43%)',
  level_0: 'linear-gradient(226.07deg, #4B4B4B66 -15.9%, #24242466 80.43%)',
};

export const borderColorLevel100 =
  'linear-gradient(270deg, #A76D60 5%, #FFFFFF 20%, #E7E7E7 26%, #A98D86 36%, #CB987D 73%, #EBEBEB 85%, #A6837A 95%)';

export const borderBottomColor = '#c8c8c880';
export const landingGuestModeButtonGradient =
  'linear-gradient(136deg, #a445b3 3.79%, #d41872 48.03%, #f06 97.19%)';
export const landingMobileActionBackdropGradient = `linear-gradient(180deg, ${color.neutral['10_alpha_0']} 14.47%, ${color.neutral[10]} 41.32%);`;
export const quickpayAuthOptionHeaderGradient =
  'linear-gradient(180deg, rgba(128, 16, 96, 0.5) 0%, rgba(0, 0, 0, 0) 100%)';

export const DotSize = {
  SIZE_0: 0,
  SIZE_8: 8,
  SIZE_12: 12,
  SIZE_16: 16,
  SIZE_20: 20,
  SIZE_26: 26,
  SIZE_28: 28,
  SIZE_32: 32,
};

export const breakpoint = {
  laptop: 1440,
  tablet: 1024,
  mobile: 768,
  // breakpoint for mobile landscape mode (height ≤ 500px)
  mobileLandscape: 500,
};

export const modalBackgroundOpacity = 0.4;
export const loadingIconOpacity = 0.6;
export const scrollBarHiddenPadding = 40;
export const tabHeight = 40;
export const desktopTabHeight = 48;

export const mobileAspectRatioWidth = 320;
export const mobileAspectRatioHeight = 454;

export const flixRowAutoPlayWidth = 520;

export const showcasePlayerMobileHeight = 240;
export const showcaseMobileWidth = 320;
export const showcaseMobileHeight = 240;
export const showcasePlayerTabletHeight = 300;
export const showcaseTabletWidth = 400;
export const showcaseTabletHeight = 300;
export const showcasePlayerDesktopHeight = 522;
export const showcaseDesktopWidth = 696;
export const showcaseDesktopHeight = 522;
// each side of item gap is 6px, the total of item gap is 12px.
export const showcaseItemGap = 12;
// each side of container is 6px, the total of container is 12px.
export const showcaseContainerGap = 12;
export const showcaseMobileMinimumItemAmount = 3;
export const showcaseDesktopMinimumItemAmount = 5;
export const showcaseSwipeTransitionSeconds = 0.35;

export const popupNotificationTopAndBottomMaximumWidth = 480;
export const popupNotificationTopAndBottomMaximumWidthInDesktop = 360;
export const popupNotificationTopAndBottomHeight = 52;
export const popupNotificationTopAndBottomHorizontalPadding = 8;
export const popupNotificationCenterMaximumWidthInPortrait = 400;
export const popupNotificationCenterMaximumHeightInLandscape = 360;
export const popupNotificationCenterHorizontalPaddingInPortrait = 24;
export const popupNotificationCenterVerticalPaddingInLandscape = 24;
export const popupNotificationCenterCloseButtonHeight = 40;
export const popupNotificationCenterContentHeightRatioInPortrait = 1.4678;
export const popupNotificationCenterContentWidthRatioInLandscape = 1.8118;
export const popupNotificationFullscreenContentHorizontalPaddingInDesktop = 32;
export const popupNotificationFullscreenContentVerticalPaddingInDesktop = 32;

export const chatBannerMaximumWidth = 359;
export const chatBannerMaximumHeight = 52;

export const freeZoneFlixCardWidth = 280;
export const freeZoneFlixCardColumnGap = 12;
export const freeZoneFlixCardPadding = 16;

export const searchSwaggerFilterHeight = 36;
export const searchStoryMessageCardWidth = 148;
export const searchStoryMessageCardWidthTablet = 122;
export const searchStoryMessageCardWidthMobile = 104;
export const searchStoryMessageCardsColumnGap = 8;
export const searchStoryMessageCardsHorizontalTotalPadding = 32;
export const searchBarHeight = 100;

export const headerZIndex = 100;

export const flixPlayerZIndex = {
  overlay: 1,
  controlDisplayedOnMobileNotification: 2,
  mask: 3,
  gestureDetector: 4,
  replayButton: 5,
  notification: 5,
  actionAnimation: 5,
  trailerBlocker: 6,
  moreButton: 7,
  backButton: 7,
  unlockButton: 6,
};

export const shortsPlayerZIndex = {
  more: 1,
  back: 1,
  playerWrapper: -1,
  playerControl: 1,
  actionWrapper: 2,
  seekBar: 3,
};

export const shopModalWidth = 360;
export const diamondPackMaxWidth = 472;
export const shopZIndex = {
  default: {},
  underShopRoot: {
    currencySelector: 3,
    paymentSourceSelector: 2,
    OrderSummary: 1,
  },
};

export const sortMenuZIndex = 10;
export const filterMenuZIndex = 10;

export const sicBoHeaderHeight = 36;
export const sicBoHeight = 264;
export const sicBoGameIdWidth = 160;
export const sicBoZIndex = 1;

export const gameMenuHeight = 232;

export const livestreamGameModalHeaderHeight = 48;
export const gameModalHeaderHeight = 62;

export const dragonTigerFightHeight = 360;
export const dragonTigerFightZIndex = 1;

// Full-screen overlay; must sit above livestream UI and other game panels.
export const ugppGameZIndex = 1000;

export const giftSlotHeaderHeight = 36;
export const giftSlotHeight = 212;
export const giftSlotZIndex = 1;

export const selectInputHeight = 48;

export const shopAsideDesktopWidth = 344; // content 328px + padding right 16px
export const shopAsideTabletWidth = 264; // content 248px + padding right 16px
export const shopAnchorAndContentGap = 12;
export const shopAnchorsZIndex = 10;
export const shopBannerDesktopHeight = 98;
export const shopBannerTabletHeight = 80;
export const shopBannerMobileHeight = 56;
export const shopLoadingMinHeight = 176;

export const missionAnchorAndContentGap = 12;
export const missionAnchorsZIndex = 10;
